import openChat from 'utils/open-chat'

export default el => {
  const triggerButtons = el.querySelectorAll('[data-trigger-selector]')

  for (const button of triggerButtons) {
    button.addEventListener('click', () => {
      const selector = button.dataset.triggerSelector

      if (!selector) {
        return
      }

      if (selector === '.online-chat' && openChat()) {
        return
      }

      const target = document.querySelector(selector)

      if (target && target !== button) {
        target.click()
      }
    })
  }
}
